const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

import Edit from "./Edit";
import metadata from "./../../../blocks/video/block.json";

registerBlockType(metadata, {
  // getEditWrapperProps: () => {},
  edit: Edit,
  save: () => {
    return null;
  },
});
